import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Card, Column, TextButton, useOverlayContext } from 'seagull';
import { ArrowDownFill } from 'seagull/icons';
import TutorialVideosModal from '~/components/NavigationAndStructure/HelpMenu/TutorialVideosModal/TutorialVideosModal';
import { openInNewTabProps } from '~/constants';
import { useIoContext } from '~/contexts';
import { ExternalLink, useHelpMenuExternalLinks } from '~/hooks/useHelpMenuExternalLinks';
import { useTutorialVideos } from '~/hooks/useTutorialVideos/useTutorialVideos';
import styles from './HelpCard.module.scss';
const HelpCard = (param)=>{
    let { className, testId } = param;
    const { externalLinks } = useHelpMenuExternalLinks({
        hideWhatsNew: true,
        menuLocation: 'setup_widget'
    });
    const { videos } = useTutorialVideos();
    const { showModal } = useOverlayContext();
    const { YoutubePlayer } = useIoContext();
    return /*#__PURE__*/ _jsxs(Card, {
        className: cn(styles.card, className),
        testId: testId,
        children: [
            /*#__PURE__*/ _jsx(Card, {
                className: styles.container,
                testId: "tutorial-video",
                as: "button",
                onClick: ()=>showModal({
                        closeOnClickOutside: true,
                        closeOnEscapeKey: true,
                        content: (param)=>{
                            let { dismissModal } = param;
                            return /*#__PURE__*/ _jsx(TutorialVideosModal, {
                                dismissModal: dismissModal
                            });
                        }
                    }),
                children: /*#__PURE__*/ _jsx(YoutubePlayer, {
                    className: styles.thumbnail,
                    playIcon: /*#__PURE__*/ _jsx(ArrowDownFill, {
                        className: styles.playIcon
                    }),
                    light: true,
                    height: 174,
                    width: 278,
                    url: "https://youtu.be/".concat(videos[0].id)
                })
            }),
            /*#__PURE__*/ _jsx(Column, {
                children: /*#__PURE__*/ _jsx(Column, {
                    className: styles.helpCardColumn,
                    children: externalLinks.map((link)=>/*#__PURE__*/ _jsx(TextButton, _object_spread_props(_object_spread({
                            testId: "help-card-link-".concat(link.label),
                            className: cn(styles.button),
                            prefixIcon: link.icon ? /*#__PURE__*/ _jsx(link.icon, {}) : null,
                            underline: "none",
                            weight: "normal",
                            variant: "paragraph1",
                            style: {
                                gap: '12px'
                            }
                        }, link.type === ExternalLink.Link ? _object_spread({
                            as: 'a',
                            href: link.href
                        }, openInNewTabProps) : {
                            onClick: link.onClick
                        }), {
                            children: link.label
                        }), link.label))
                })
            })
        ]
    });
};
export default HelpCard;
